import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { finanzasService } from '../services/finanzas.service';
import deudasService from '../services/deudas.service';
import { useAuthStore } from '../store/useAuthStore';
import { useWorkspaceStore } from '../store/useWorkspaceStore';

export const useTransaccionesQuery = () => {
  const { token } = useAuthStore();
  const { activeWorkspaceId } = useWorkspaceStore();
  
  return useQuery({
    queryKey: ['transacciones', activeWorkspaceId],
    queryFn: finanzasService.getFinanzas,
    enabled: !!token && activeWorkspaceId !== 'default',
    initialData: [],
  });
};

export const useMetasQuery = () => {
  const { token } = useAuthStore();
  const { activeWorkspaceId } = useWorkspaceStore();
  
  return useQuery({
    queryKey: ['metas', activeWorkspaceId],
    queryFn: finanzasService.getMetas,
    enabled: !!token && activeWorkspaceId !== 'default',
    initialData: [],
  });
};

export const useCrearTransaccionMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: finanzasService.crearFinanza,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transacciones'] });
    },
  });
};

export const useEliminarTransaccionMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: finanzasService.eliminarFinanza,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transacciones'] });
    },
  });
};

export const useCrearMetaMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: finanzasService.crearMeta,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['metas'] });
    },
  });
};

export const useActualizarMetaMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: finanzasService.actualizarMeta,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['metas'] });
    },
  });
};

export const useEliminarMetaMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: finanzasService.eliminarMeta,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['metas'] });
    },
  });
};

export const useDeudasQuery = () => {
  const { token } = useAuthStore();
  const { activeWorkspaceId } = useWorkspaceStore();
  
  return useQuery({
    queryKey: ['deudas', activeWorkspaceId],
    queryFn: deudasService.getDeudas,
    enabled: !!token && activeWorkspaceId !== 'default',
    initialData: [],
  });
};

export const useCrearDeudaMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: deudasService.createDeuda,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['deudas'] });
    },
  });
};

export const useActualizarDeudaMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data) => deudasService.updateDeuda(data.id, data.datos),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['deudas'] });
    },
  });
};

export const useEliminarDeudaMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: deudasService.deleteDeuda,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['deudas'] });
    },
  });
};
